import { Factory } from '../../services/Factory';

namespace app.controllers.project {

  import ProjectService = app.services.project.ProjectService;
  import CollectionService = app.services.collections.CollectionService;
  import OrganizationService = app.services.organization.OrganizationService;

  export class GetStartedController {
    constructor($scope, $rootScope, $routeParams, $modalInstance, projectService: ProjectService, collectionService: CollectionService, organizationService: OrganizationService, navigationService) {
      navigationService.setActiveTab('projects', 'getstarted');
      collectionService.ClearCurrentCollection();
      $rootScope.$broadcast("navigation.batch.deselect");

      projectService.FindOneOrCurrentProject({id: $routeParams.projectId}).then(async project => {
        $scope.project = project;
        if (project.type === "organization_project") {
          $scope.organization = await organizationService.FindOne({ id: project.organizationId });

          organizationService.SetCurrentOrganization($scope.organization);
        } else {
          organizationService.ClearCurrentOrganization();
        }

        projectService.SetCurrentProject(project);

        $scope.$applyAsync();
      });

      $scope.openNewCollectionDialog = function() {
        $modalInstance.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl:  "partials/dialog_collection.html",
          controller: "AddCollectionController",
          scope: $scope,
          resolve: {
            project: function() { return $scope.project }
          },
          windowClass: "iio-large-modal"
        });
      };
    }
  }

  frontendApp.controller("GetStartedController", ["$scope", "$rootScope", "$routeParams", "$uibModal", "ProjectService", "CollectionService", "OrganizationService", "NavigationService", Factory.Create(GetStartedController)]);
}
